module.exports = "/static/assets/738a69d73a36644e21fc17a00b1bf3c8.png";